 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/addExecuteProject/index/pages/approvalInfo/index/pages/approvalQuery/index/pages/channelApprov/94078893","2":"pages/addExecuteProject/index/pages/approvalInfo/index/pages/attachmentUpload/index/pages/channelApp/f5da8137","3":"vendors/pages/addExecuteProject/index/pages/approvalInfo/index/pages/channelDetail/index/pages/confi/9e31d5d6","5":"pages/flushRedList/index","6":"pages/partner/index/pages/partnerQuery/index","7":"pages/projectControl/index","12":"pages/GABContractList/index","13":"pages/GABandMCN/index","14":"pages/SCSupplyDate/index","15":"pages/addExecuteProject/index","16":"pages/approvalInfo/index","17":"pages/approvalQuery/index","18":"pages/attachmentUpload/index","19":"pages/channelApproval/index","20":"pages/channelApprovalDetail/index","21":"pages/channelDelay/index","22":"pages/channelDelayDetail/index","23":"pages/channelDetail/index","24":"pages/channelGradeMaintenance/index","25":"pages/channelIsgCenter/index","26":"pages/channelIsgCenterDetail/index","27":"pages/channelManagerMaintenance/index","28":"pages/channelOpportunities/index","29":"pages/channelSelectCustomer/index","30":"pages/configurationCenter/index","31":"pages/configurationCenterList/index","32":"pages/contractDetail/index","33":"pages/contractSelectContacts/index","34":"pages/contractSelectCustomer/index","35":"pages/d365/index","36":"pages/editValidityDate/index","37":"pages/example/index","38":"pages/fillinCustomerInfo/index","39":"pages/flushRedListBussi/index","40":"pages/flushRedProjectDetail/index","41":"pages/frameContractList/index","42":"pages/gabCodeRelationMaintenance/index","43":"pages/history/index","44":"pages/index","45":"pages/info/index","46":"pages/info/table","47":"pages/kittingInfo/controller/action","48":"pages/kittingInfo/index","49":"pages/lmcVerification/index","50":"pages/lowPriceDescription/index","51":"pages/micro/index","52":"pages/modelNoPreserve/index","53":"pages/navigation/index","54":"pages/opportunity/index","55":"pages/partner/index","56":"pages/partnerQuery/index","57":"pages/partnerSecondDealer/index","58":"pages/priceWhiteList/index","59":"pages/project/index","60":"pages/projectControlPricer/index","61":"pages/projectDetail/index","62":"pages/projectFlushRed/index","63":"pages/quotationKit/index","64":"pages/quotationKitDetail/index","65":"pages/removeWhiteList/index","66":"pages/removeWhiteListDetails/index","67":"pages/serviceQuery/index","68":"pages/siInfo/index","69":"pages/siQuery/index","70":"pages/transfer/index"}[chunkId]||chunkId) + "." + {"1":"28b76dc","2":"8156ffb","3":"2f17278","4":"32ad866","5":"19d6aaa","6":"20ed12a","7":"74e44bb","8":"54d2990","9":"2632dbe","12":"c948db2","13":"2c49478","14":"d105faa","15":"201c3f1","16":"0b7a390","17":"50e9675","18":"4a9f760","19":"4a3eb10","20":"2ef478f","21":"3b81b99","22":"b2bc332","23":"269ae60","24":"4293e84","25":"4607f2e","26":"802f034","27":"fdeb8bc","28":"d687e6a","29":"c9f6fe2","30":"4c8e844","31":"8c0579c","32":"dd43596","33":"2011965","34":"9cd4341","35":"a27fcf0","36":"76aedfa","37":"739c76c","38":"89ed4be","39":"e45db46","40":"2872062","41":"78083df","42":"88f9437","43":"d4c2f10","44":"c60a622","45":"8d43ff8","46":"3a6c374","47":"7659587","48":"d5e19d1","49":"4cb99d9","50":"8fed337","51":"93d9a50","52":"164a55c","53":"cd01ffd","54":"abc576a","55":"40b40cf","56":"945de2a","57":"c35f2f4","58":"a6598d1","59":"6bdcade","60":"def6290","61":"cc7b4a3","62":"86193c5","63":"5449636","64":"7535ea0","65":"efcc495","66":"7ee3d43","67":"2736aa6","68":"8b034ad","69":"387e1f1","70":"ddd4a84","72":"3374462","73":"8d0fde7","74":"ca0f5f5","75":"6f9b85c","76":"0fbe847","77":"14d39f6","78":"fbc1d2b","79":"6f572d4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackjson_cbp_quotation_0_0_1"] = window["webpackjson_cbp_quotation_0_0_1"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
